// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"270":"5f0dabfe","453":"447c1f3c","723":"a7562233","836":"3100c064"}[chunkId] + ".chunk.js";
};